import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../../context/ThemeProvider';
import ColorSchemePicker from './ColorSchemePicker';

const AppearanceControls = () => {
  const { theme, colorScheme, setColorScheme, toggleTheme, appearanceError } = useTheme();
  const modeLabel = theme === 'dark' ? 'Use light appearance' : 'Use dark appearance';

  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      <ColorSchemePicker value={colorScheme} onChange={setColorScheme} />
      <button
        type="button"
        aria-label={modeLabel}
        title={modeLabel}
        onClick={toggleTheme}
        className="photon-button-quiet flex h-9 w-9 shrink-0 items-center justify-center rounded-md"
      >
        {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      </button>
      {appearanceError && <p role="alert" className="w-full text-right text-xs text-ink-red-500">{appearanceError}</p>}
    </div>
  );
};

export default AppearanceControls;